import { useFormContext } from 'react-hook-form'
import { BefehlFormAuftrag } from '../Generic'
import { useTranslation } from 'react-i18next'

export interface Auftrag2_10FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings: boolean
}

export default function Auftrag2_10Form({
  readOnly,
  'data-testid': testId,
  activateEmptyFieldWarnings
}: Readonly<Auftrag2_10FormProps>) {
  const { control } = useFormContext()
  const { t } = useTranslation('ui-befehle')

  return (
    <BefehlFormAuftrag
      auftragKennung="2.10"
      fieldName="auftrag_2_10.enabled"
      control={control}
      readOnly={readOnly}
      testId={testId}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
    >
      <div className="flex items-baseline gap-2" data-testid={`${testId}-text`}>
        {t('auftraege.2_10.label')}
      </div>
    </BefehlFormAuftrag>
  )
}
